import React, { Component } from "react";
import PreviewLabel from "./PreviewLabel/PreviewLabel";
import StatsRow from "./StatsRow/StatsRow";
import ButtonAlt from "../ButtonAlt/ButtonAlt";
import "./CompanyResults.css";

class CompanyResults extends Component {
	componentWillMount() {
		this.query = this.props.getQuery();
		this.retrievedCompanyInfo = this.props.findCompanyInSearchResults();
		this.props.findCompanyContacts();
		this.company = this.retrievedCompanyInfo["companyInfo"];
	}
	renderSentences(type) {
		return this.company[type].map((s, index) => {
			let sentence = {
				__html: isNaN(Number(s.score))
					? s.sentence
					: `${s.score} - ${s.sentence}`
			};

			return <p key={index} dangerouslySetInnerHTML={sentence} />;
		});
	}
	
	renderAnalogySentences(type) {
		return this.company[type].map((s, index) => {
			let sentence = {
				__html: isNaN(Number(s.score))
					? s.sentence`<br>`
					: `Relevance= ${s.score} ${s.sentence}<br>`
			};

			return <p key={index} dangerouslySetInnerHTML={sentence} />;
		});
	}	
	
	renderClaimSentences(type) {
		return this.company[type].map((s, index) => {
			let sentence = {
				__html: isNaN(Number(s.score))
					? s.sentence`<br>`
					: `Relevance= ${s.score}<br>${s.sentence}<br><br>`
			};

			return <p key={index} dangerouslySetInnerHTML={sentence} />;
		});
	}
	
	renderTransactionSentences(type) {
		return this.company[type].map((s, index) => {
			let sentence = {
				__html: isNaN(Number(s.score))
					? s.sentence`<br>`
					: `Relevance= ${s.score}<br>${s.sentence}<br>`
			};

			return <p key={index} dangerouslySetInnerHTML={sentence} />;
		});
	}
		
	render() {
		// find company data according to url's id param

		let renderCompContacts = this.props.companyContacts.map((c, index) => {
			let name = { __html: c.name };
			let linkedIn = { __html: c.linkedin.replace(" linkedin ", "LinkedIn") };

			return (
				c.primary_affiliation_title && (
					<div className="comp-contact-section" key={index}>
						<p className="comp-contact-name" dangerouslySetInnerHTML={name} />
						<p className="comp-contact-title">{c.primary_affiliation_title}</p>
						<p className="comp-contact-title">{c.primary_affiliation_organization}</p>
						<p
							className="comp-contact-link"
							dangerouslySetInnerHTML={linkedIn}
						/>
					</div>
				)
			);
		});

		return (
			<div className="company-results-page container">
				<PreviewLabel company={this.company} />
				<StatsRow company={this.company} />
				<div className="company-results-text">
					{this.company.category && (
						<div>
							<h2>CATEGORY</h2>
							<p>{this.company.category}</p>
						</div>
					)}
					<h2>DESCRIPTION</h2>
					<p>
						{this.company.description
							? this.company.description
							: "Data unavailable"}
					</p>
					<h2>Web</h2>
					<p>
						{this.company.web
							? this.company.domain
							: "Data unavailable"}
					</p>
					{this.query.type === "customers" &&
						this.props.companyContacts.length > 0 && (
							<div>
								<h2>CONTACTS</h2>
								<ButtonAlt
									label={
										this.props.showCompanyContacts
											? "Close Contacts"
											: "View All Contacts"
									}
									onClick={() => this.props.toggleCompanyContacts()}
								/>
							</div>
						)}
					{this.props.companyContacts.length !== 0 &&
						this.props.showCompanyContacts === true &&
						renderCompContacts}

					{this.company.analogies && (
						<div>
							<h2>Analogies</h2>
							{this.renderAnalogySentences("analogies")}
						</div>
					)}
					{this.company.neighbors && (
						<div>
							<h2>Neighbors</h2>
							{this.renderSentences("neighbors")}
						</div>
					)}
					{this.company.transactions && (
						<div>
							<h2>Related Transactions</h2>
							{this.renderTransactionSentences("transactions")}
						</div>
					)}
					{this.company.documents && (
						<div>
							<h2>Related Documents</h2>
							{this.renderTransactionSentences("documents")}
						</div>
					)}
					{this.company.talks && (
						<div>
							<h2>Recent Talks</h2>
							{this.renderClaimSentences("talks")}
						</div>
					)}
					{this.company.claims && (
						<div>
							<h2>Related Claims</h2>
							{this.renderClaimSentences("claims")}
						</div>
					)}

				</div>
			</div>
		);
	}
}

export default CompanyResults;


// WEBPACK FOOTER //
// ./src/components/CompanyResults/CompanyResults.js